import { Component, OnInit, ViewChild } from '@angular/core';
import { ColDef, Column, ColumnApi, GridApi, GridOptions, GridReadyEvent } from 'ag-grid-community';
import { BtnCellRenderer } from 'src/app/common/button-cell-renderer.component';
import { BtnCellRenderer1 } from 'src/app/common/button-cell-renderer.component1';
import { environment } from 'src/environments/environment';
import { SuperTransactionsService } from '../super-transactions.service';
import { ModalComponent } from 'src/app/common/modal/modal.component';
import { ModalConfig } from 'src/app/common/modal/modal.config';
import { Router } from '@angular/router';
import { MenusService } from 'src/app/_services/menu.service';
import { AlertService } from 'src/app/_services/alert.service';
import { Location } from '@angular/common';
import { PiiGridService } from 'src/app/_services/pii-grid.service';
import { PiiCellRendererComponent } from 'src/app/common/pii-cell-renderer.component';

const { API_URL, defaultPageSizeArr, defaultPageSize } = environment;


@Component({
  selector: 'app-super-transaction-list',
  templateUrl: './super-transaction-list.component.html',
  styleUrls: ['./super-transaction-list.component.scss']
})
export class SuperTransactionListComponent implements OnInit {


  @ViewChild('modalSuperTransaction') private modalSuperTransaction: ModalComponent;
  private gridApi!: GridApi;
  public gridOptions: GridOptions;
  private gridColumnApi!: ColumnApi;
  public pageSize: number = defaultPageSize;
  public pageNumber: number = 0;
  public pageSizeArr: any = defaultPageSizeArr;
  public rowData: any[] = [];
  public modalSuperTransactionConfig: ModalConfig;
  currentPage: number = 1;
  collectionSize: number = 0;
  searchedSuperTransaction: any;
  public permissions: string = '';

  public defaultColDef: ColDef = {
    flex: 1,
    minWidth: 170,
    resizable: true,
    sortable: false,
    filter: false,
    autoHeight: true
  };

  public columnDefs: ColDef[] = [
    { field: 'id', headerName: 'Adjustment ID', lockVisible: true, },
    { field: 'txnId', headerName: 'Txn ID', lockVisible: true, },
    { field: 'originalTxnId', headerName: 'Original Txn ID', lockVisible: true, },
    { field: 'dateOfTransaction', headerName: 'Date of Original Txn', lockVisible:true,},
    { field: 'senderWalletId', headerName: 'Debiting Wallet ID',lockVisible:true, width: 200, minWidth: 150 },
    { field: 'receiverWalletId', headerName: 'Crediting Wallet ID', lockVisible: true, width: 200, minWidth: 150 },
    // { field: 'senderMobileNumber', headerName: 'Sender Mobile', lockVisible: true },
    // { field: 'receiverMobileNumber', headerName: 'Receiver Mobile', lockVisible: true},
    // { field: 'senderName', headerName: 'Sender Name', lockVisible: true},
    // { field: 'receiverName', headerName: 'Receiver Name', lockVisible: true },
    { field: 'totalAmount', headerName: 'Credit Amount', lockVisible: true,cellRenderer: PiiCellRendererComponent, width: 500, minWidth: 200 },
    { field: 'createdOn', headerName: 'Adjustment Posting Date' ,lockVisible:true  },
    { field: 'currency',  headerName: 'Currency',lockVisible:true, },
    { field: 'adjustmentType',  headerName: 'Adjustment', lockVisible:true,},
    { field: 'createdBy', headerName: 'Processed By', lockVisible: true, },
    { field: 'status', headerName: 'Status', lockVisible: true, },
    {
      field: 'unmasking', headerName: 'Unmasking',lockVisible:true, width: 120, cellRenderer: BtnCellRenderer1, cellRendererParams: [
        {
          clicked: async (event: any, param: any) => {
            // Toggle PII unmask for the entire row
            this.piiGridService.unmaskRow(param.data, this.gridApi);
          },
          buttonIconClass: 'icon-frame-1',
          buttonText: '',
          buttonVisible: true,
          customImage: 'assets/images/unmask-icon.png'
        }
      ]
    },
    {
      field: 'actions', headerName: 'Actions',lockVisible:true, width: 120, cellRenderer: BtnCellRenderer1, cellRendererParams: [
        {
          clicked: (event: any, param: any) => {
            this.showDetails(param.data.id);
          },
          buttonIconClass: 'icon-maximize',
          buttonVisible: true
        }
      ]
    }
  ];

  constructor(private superTransactionService: SuperTransactionsService, private location: Location, private router: Router, private menuService: MenusService, private alertService: AlertService, private piiGridService: PiiGridService) { }

  async ngOnInit(): Promise<void> {
    const path = this.location.prepareExternalUrl(this.location.path());
    this.permissions = this.menuService.getPermissions(path);
    if (this.permissions == null || this.permissions == '' || !this.permissions) {
      this.alertService.errorAlert({
        title: "No Access",
        backdrop: true,
        toast: true,
        timer: 1500
      })
      await this.router.navigateByUrl('/');
    }
    this.modalSuperTransactionConfig = {
      modalTitle: "Super Transaction",
      modalSize: 'xl',


      hideDismissButton(): boolean {
        return true
      },
      hideCloseButton(): boolean {
        return true
      }
    }
  }

  onGridReady(params: GridReadyEvent<any>) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    const allColumnIds: (string | Column)[] = [];
    params?.columnApi?.getColumns()?.forEach((column) => {
      allColumnIds.push(column.getId());
    });
    params?.columnApi?.autoSizeColumns(allColumnIds, false);
    this.refreshData(null)
  }


  handleResponse(resp: any) {
    console.log(resp);
    this.rowData = resp?.response?.data?.content ?? [];
    this.collectionSize = resp?.response?.data?.totalElements ?? 0
  }

  updatePage(page: number){
    this.currentPage = page;
    this.refreshData(null);
  }

  refreshData(event: any) {
    this.gridApi.applyTransaction({ remove: this.rowData })
    this.gridApi.showLoadingOverlay();
    var pageNo = this.currentPage - 1;
    var pageSize = this.pageSize;
    this.superTransactionService.getSuperTransactions({
      page_no: pageNo,
      page_size: pageSize,
      sort_dir: "DESC",
      sort_column: "createdOn"
    }).subscribe((resp) => {
      this.handleResponse(resp)
    })
  }

  showDetails(id: string){
    this.superTransactionService.getSuperTransaction(id).subscribe((resp : any)=>{
      this.handleSearchResponse(resp)
    });
  }

  handleSearchResponse(resp : any){
    var response = resp.response.data ?? {};
    this.searchedSuperTransaction = {};
    this.searchedSuperTransaction.txnId = response.txnId;
    this.searchedSuperTransaction.senderWalletId = response.senderWalletId;
    this.searchedSuperTransaction.receiverWalletId = response.receiverWalletId;
    this.searchedSuperTransaction.senderMobileNumber = response.senderMobileNumber;
    this.searchedSuperTransaction.receiverMobileNumber = response.receiverMobileNumber;
    this.searchedSuperTransaction.senderName = response.senderName;
    this.searchedSuperTransaction.receiverName = response.receiverName;
    this.searchedSuperTransaction.senderVirtualIBAN = response.senderVirtualIBAN;
    this.searchedSuperTransaction.receiverVirtualIBAN = response.receiverVirtualIBAN;
    this.searchedSuperTransaction.channelId = response.channelId;
    this.searchedSuperTransaction.transactionDate = response.transactionDate;  // ISO string
    this.searchedSuperTransaction.originalAmount = response.originalAmount;
    this.searchedSuperTransaction.originalFee = response.originalFee;
    this.searchedSuperTransaction.originalVat = response.originalVat;
    this.searchedSuperTransaction.currency = response.currency;
    this.searchedSuperTransaction.amount = response.amount ?? {};
    this.searchedSuperTransaction.fee = response.fee ?? {};
    this.searchedSuperTransaction.vat = response.vat ?? {};
    this.searchedSuperTransaction.reason = response.reason;
    this.searchedSuperTransaction.remarks = response.remarks;
    this.searchedSuperTransaction.message = response.message;
    this.modalSuperTransaction.open();
  }
}
